"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLinks = exports.insertLink = exports.wrapLink = exports.unwrapLink = exports.isLinkActive = void 0;
/* eslint-disable no-param-reassign */
var is_url_1 = __importDefault(require("is-url"));
var slate_1 = require("slate");
var isLinkActive = function (editor) {
    var _a = __read(slate_1.Editor.nodes(editor, { match: function (n) { return n.type === 'link'; } }), 1), link = _a[0];
    return !!link;
};
exports.isLinkActive = isLinkActive;
var unwrapLink = function (editor) {
    slate_1.Transforms.unwrapNodes(editor, { match: function (n) { return n.type === 'link'; } });
};
exports.unwrapLink = unwrapLink;
var wrapLink = function (editor, url) {
    if (exports.isLinkActive(editor)) {
        exports.unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && slate_1.Range.isCollapsed(selection);
    var link = {
        type: 'link',
        url: url,
        children: isCollapsed ? [{ text: url }] : [],
    };
    if (isCollapsed) {
        slate_1.Transforms.insertNodes(editor, link);
    }
    else {
        slate_1.Transforms.wrapNodes(editor, link, { split: true });
        slate_1.Transforms.collapse(editor, { edge: 'end' });
    }
};
exports.wrapLink = wrapLink;
var insertLink = function (editor, url) {
    if (editor.selection) {
        exports.wrapLink(editor, url);
    }
};
exports.insertLink = insertLink;
var withLinks = function (editor) {
    var insertData = editor.insertData, insertText = editor.insertText, isInline = editor.isInline;
    editor.isInline = function (element) {
        return element.type === 'link' ? true : isInline(element);
    };
    editor.insertText = function (text) {
        if (text && is_url_1.default(text)) {
            exports.wrapLink(editor, text);
        }
        else {
            insertText(text);
        }
    };
    editor.insertData = function (data) {
        var text = data.getData('text/plain');
        if (text && is_url_1.default(text)) {
            exports.wrapLink(editor, text);
        }
        else {
            insertData(data);
        }
    };
    return editor;
};
exports.withLinks = withLinks;
exports.default = exports.withLinks;
//# sourceMappingURL=withLinks.js.map